import {resolveBackground} from '#core/utils/color-utils.js';
import {isMobile} from '#core/utils/context-utils.js';

import {AbstractVisualFeature} from '#core/application/modules/visual-feature.js';
import {PRICE_BOOST_ICON_SRC} from '#core/application/modules/tiles/price-boost-label/index.js';
import {generateBorder} from '#core/application/modules/tiles/border/index.js';

import {MenusLinksLists} from '../menus-links-list.js';

import PALETTE_SCHEMA from './desktop-cms-links.palette-schema.yaml';

class DesktopCMSLinksFeature extends AbstractVisualFeature {
    get enabled() {
        return !isMobile();
    }

    get paletteSchema() {
        return PALETTE_SCHEMA;
    }

    getSerializableVisualConfig(PALETTE) {
        return {
            PageContextMenu: {
                priceBoostLink: {
                    icon: {
                        src: PRICE_BOOST_ICON_SRC,
                        style: {
                            fill: PALETTE.DESKTOP_CMS_LINKS_ITEM_ICON_COLOR,
                            marginRight: 8,
                        },
                    },
                },
                baseLink: {
                    iconContainer: {
                        style: {
                            minWidth: 'unset',
                        },
                    },
                    icon: {
                        style: {
                            fill: PALETTE.DESKTOP_CMS_LINKS_ITEM_ICON_COLOR,
                            marginRight: 8,
                        },
                    },
                },
                tileLinkMenu: {
                    regularContainer: {
                        style: {
                            ...resolveBackground(PALETTE.DESKTOP_CMS_LINKS_BG),
                            ...generateBorder(PALETTE.DESKTOP_CMS_LINKS_BORDER),
                            overflow: 'hidden', // needed for round corners
                        },
                    },
                    headerContainer: {
                        style: {
                            ...(PALETTE.DESKTOP_CMS_LINKS_SHOW_HEADER_UNDERLINE
                                ? {
                                      borderWidth: '0 0 1px 0',
                                      borderColor: PALETTE.DESKTOP_CMS_LINKS_HEADER_UNDERLINE_COLOR,
                                      borderStyle: 'solid',
                                  }
                                : {}),
                            ...resolveBackground(PALETTE.DESKTOP_CMS_LINKS_HEADER_BG), // have to use resolveBackground
                            padding: '8px',
                            height: 40,
                            alignItems: 'center',
                            order: -2, // todo rework on MOJ-15405
                        },
                    },
                    header: {
                        style: PALETTE.DESKTOP_CMS_LINKS_HEADER_TEXT,
                    },
                    regularItem: {
                        unselected: {
                            style: {
                                base: {
                                    padding: '8px',
                                    _mobile_padding: '8px 8px 8px 16px',
                                    alignItems: 'center',
                                    minHeight: '40px',
                                    ...PALETTE.DESKTOP_CMS_LINKS_ITEM.LIST_ITEM_TEXT,
                                    ...(PALETTE.DESKTOP_CMS_LINKS_ITEM.LIST_ITEM_SHOW_SEPARATOR
                                        ? {
                                              _desktop_borderWidth: '0 0 1px 0',
                                              _mobile_borderWidth: '0 0 1px 0',
                                              borderColor: PALETTE.DESKTOP_CMS_LINKS_ITEM.LIST_ITEM_SEPARATOR_COLOR,
                                              borderStyle: 'solid',
                                          }
                                        : {
                                              borderWidth: 0,
                                          }),
                                },
                            },
                        },
                        indicator: {
                            style: {
                                base: {
                                    height: 0,
                                    backgroundColor: 'transparent',
                                },
                            },
                        },
                    },
                    regularLabel: {
                        // keep it empty. All styles are inherited from regularItem.unselected.style.base
                        style: {
                            overflowWrap: 'anywhere',
                        },
                    },
                },
            },
        };
    }
}

new DesktopCMSLinksFeature(MenusLinksLists);
